





























import { Vue, Prop, Component } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
@Component({
  components: { CustomButton }
})
export default class DeleteMaterialModal extends Vue {
  @Prop() entity?: any;
  @Prop({ default: false }) isAction!: boolean;
  @Prop({ default: "modal-1" }) id!: string;

  deleteEntity() {
    this.$emit("deleteAccepted", this.id);
  }

  showModal() {
    this.$bvModal.show(this.id);
  }

  hideModal() {
    this.$bvModal.hide(this.id);
    this.$emit("cancel");
  }

  mounted() {
    if (this.entity) {
      this.showModal();
    }
  }
}
